<template>
  <v-dialog v-model="dialogShow" persistent width="520" height="285" class="dialog">
    <v-card>
      <v-card-title class="dialogTitle">
        <p class="dialogTitle-title">新建文件</p>
        <v-spacer></v-spacer>
        <p @click="closeDialog" class="dialogTitle-close iconfontFamily">&#xe60d;</p>
      </v-card-title>
      <v-card-text style="padding:41px 48px 30px 39px;">
        <div style="display:flex;align-items:center;">
          <p style="font-size:16px;color:#000000;">文件名</p>
          <v-text-field v-model="folderName" placeholder="请输入文件名" dense outlined hide-details width="339" height="36" style="margin-left:46px;"></v-text-field>
        </div>
        <p :style="{'visibility':errorShow ? 'visible' : 'hidden'}" style="margin-left:93px;margin-top:5px;font-size:14px;color:#ff0000;"><span class="iconfontFamily">&#xe71f;</span>{{errorText}}</p>
        <div style="margin-top:49px;text-align:right;">
          <v-btn @click="createFolder" width="100" height="33" dark color="#1E3A8A">新建</v-btn>
        </div>
      </v-card-text>
    </v-card>


    <v-dialog v-model="oldFolderCloseDialogShow" persistent max-width="540">
      <v-card>
        <v-card-title class="tipsDialog-title">
          温馨提示
          <v-spacer></v-spacer>
          <p @click="oldFolderCloseDialogShow = false" class="tipsDialog-close iconfontFamily">&#xe60d;</p>
        </v-card-title>
        <v-card-text class="tipsDialog-mainArea">
          <div style="display:flex;align-items:center">
            <p class="tipsDialog-mainArea-icon iconfontFamily">&#xe627;</p>
            <p class="tipsDialog-mainArea-text">新建文件会失去当前未保存内容，是否继续？</p>
          </div>
          <div class="tipsDialog-mainArea-btnLine">
            <v-btn @click="oldFolderCloseDialogShow = false" width="100" height="35" color="#F5F5F5">取消</v-btn>
            <v-btn @click="oldFolderCloseOK" width="100" height="35" dark color="#1E3A8A" style="margin-left:50px;">确定</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-dialog>
</template>

<script>
export default {
  name: "CreateSceneFolder",
  props:["dialogShow"],
  data(){
    return{

      folderName:"",

      errorShow:false,
      errorText:"",

      //离开旧文件夹弹窗
      oldFolderCloseDialogShow:false,


    }

  },
  methods:{
    closeDialog(){
      this.$emit("closeDialog","")
    },


    //创建文件夹
    createFolder(){
      if(this.folderName.length > 30){
        this.errorText = "文件名超出30字"
        this.errorShow = true;
      }
      else if(this.folderName.trim().length === 0){
        this.errorText = "文件名不能为空"
        this.errorShow = true;
      }
      else{
        if(this.$store.state.globeQuitShowDialog){
          this.oldFolderCloseDialogShow = true;
        }
        else{
          this.$axios({
            method:"post",
            url:"/authorApi/z-screen-recorder/newRecord",
            params:{
              recordName:this.folderName
            }
          }).then((resultData)=>{
            resultData = resultData.data;
            console.log(resultData)
            if(resultData.status === 200){
              this.$emit("createFolderOk",resultData.data)
            }
            else if(resultData.status === 309){
              this.errorText = "已存在同名文件"
              this.errorShow = true;
            }
            else{
              console.log(resultData.status + resultData.message);
            }
          }).catch((err)=>{
            console.log(err);
          });
        }



      }


    },
    oldFolderCloseOK(){
      this.oldFolderCloseDialogShow = false;
      this.$axios({
        method:"post",
        url:"/authorApi/z-screen-recorder/newRecord",
        params:{
          recordName:this.folderName
        }
      }).then((resultData)=>{
        resultData = resultData.data;
        console.log(resultData)
        if(resultData.status === 200){
          this.$emit("createFolderOk",resultData.data)
        }
        else if(resultData.status === 309){
          this.errorText = "已存在同名文件"
          this.errorShow = true;
        }
        else{
          console.log(resultData.status + resultData.message);
        }
      }).catch((err)=>{
        console.log(err);
      });
    },



  }

}
</script>

<style scoped>

</style>